import Vue from 'vue';
import VueRouter from 'vue-router';
import goTo from 'vuetify/lib/services/goto';

// layouts
const DefaultLayout = () => import(/* webpackChunkName: "chunk/default-layout" */ '@/components/layouts/DefaultLayout');

// views
const ApplyForm = () => import(/* webpackChunkName: "chunk/apply" */ '@/components/views/ApplyForm');

// errors
const NotFound = () => import(/* webpackChunkName: "chunk/not-found" */ '@/components/views/error/NotFound');

const routes = [
  layout('/', DefaultLayout, [
    route('apply', ApplyForm, {name: 'apply', meta: {title: '오렌즈 아카데미 지원'}, alias: ['']}),
  ]),
  route('*', NotFound, {meta: {title: '페이지가 없습니다'}}),
];

Vue.use(VueRouter);

const router = new VueRouter({
  mode: 'history',
  base: __dirname,
  routes,
  scrollBehavior: (to, from, savedPosition) => {
    let scrollTo = 0;

    if (to.hash) {
      scrollTo = to.hash;
    } else if (savedPosition) {
      scrollTo = savedPosition.y;
    }

    return goTo(scrollTo, {duration: 0});
  },
});

router.beforeEach((to, from, next) => {
  document.title = '오렌즈 아카데미 - ' + to.meta.title;

  return next();
});

export function layout(path, component, children = [], meta = {}) {
  if (typeof path === 'string') path = {path};
  return {
    ...path,
    component,
    props: true,
    meta: meta,
    children,
  };
}

export function route(path, component, route = {}) {
  return {
    path,
    component,
    props: true,
    ...route,
  };
}

export default router;
